import { render, staticRenderFns } from "./GoodsMiaosha.vue?vue&type=template&id=934109a8&"
import script from "./GoodsMiaosha.vue?vue&type=script&lang=js&"
export * from "./GoodsMiaosha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports